module.exports = __webpack_public_path__ + "static/media/profile-icon-active.3fb30d1d.png";